// src/crypto/base64url.ts
var ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
var LOOKUP = new Int16Array(128).fill(-1);
for (let i = 0; i < ALPHABET.length; i++) LOOKUP[ALPHABET.charCodeAt(i)] = i;
function toBase64Url(bytes) {
  let out = "";
  const n = bytes.length;
  let i = 0;
  for (; i + 2 < n; i += 3) {
    const v = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
    out += ALPHABET[v >> 18] + ALPHABET[v >> 12 & 63] + ALPHABET[v >> 6 & 63] + ALPHABET[v & 63];
  }
  const rest = n - i;
  if (rest === 1) {
    const v = bytes[i] << 16;
    out += ALPHABET[v >> 18] + ALPHABET[v >> 12 & 63];
  } else if (rest === 2) {
    const v = bytes[i] << 16 | bytes[i + 1] << 8;
    out += ALPHABET[v >> 18] + ALPHABET[v >> 12 & 63] + ALPHABET[v >> 6 & 63];
  }
  return out;
}
function fromBase64Url(text) {
  const len = text.length;
  if (len % 4 === 1) throw new TypeError("invalid base64url length");
  const out = new Uint8Array(Math.floor(len * 3 / 4));
  let o = 0;
  let i = 0;
  const sextet = (k) => {
    const c = text.charCodeAt(k);
    const v = c < 128 ? LOOKUP[c] : -1;
    if (v < 0) throw new TypeError(`invalid base64url character at ${k}`);
    return v;
  };
  for (; i + 3 < len; i += 4) {
    const v = sextet(i) << 18 | sextet(i + 1) << 12 | sextet(i + 2) << 6 | sextet(i + 3);
    out[o++] = v >> 16;
    out[o++] = v >> 8 & 255;
    out[o++] = v & 255;
  }
  const rest = len - i;
  if (rest === 2) {
    const v = sextet(i) << 18 | sextet(i + 1) << 12;
    if (v & 65535) throw new TypeError("non-canonical base64url");
    out[o++] = v >> 16;
  } else if (rest === 3) {
    const v = sextet(i) << 18 | sextet(i + 1) << 12 | sextet(i + 2) << 6;
    if (v & 255) throw new TypeError("non-canonical base64url");
    out[o++] = v >> 16;
    out[o++] = v >> 8 & 255;
  }
  return out;
}
var encoder = new TextEncoder();
var decoder = new TextDecoder("utf-8", { fatal: true });
function utf8(text) {
  return encoder.encode(text);
}
function fromUtf8(bytes) {
  return decoder.decode(bytes);
}
function concatBytes(...parts) {
  let total = 0;
  for (const p of parts) total += p.length;
  const out = new Uint8Array(total);
  let off = 0;
  for (const p of parts) {
    out.set(p, off);
    off += p.length;
  }
  return out;
}
function bytesEqual(a, b) {
  if (a.length !== b.length) return false;
  let diff = 0;
  for (let i = 0; i < a.length; i++) diff |= a[i] ^ b[i];
  return diff === 0;
}
function toHex(bytes) {
  let s = "";
  for (const b of bytes) s += b.toString(16).padStart(2, "0");
  return s;
}
function fromHex(hex) {
  if (hex.length % 2 !== 0 || !/^[0-9a-fA-F]*$/.test(hex)) throw new TypeError("invalid hex");
  const out = new Uint8Array(hex.length / 2);
  for (let i = 0; i < out.length; i++) out[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
  return out;
}

export { bytesEqual, concatBytes, fromBase64Url, fromHex, fromUtf8, toBase64Url, toHex, utf8 };
//# sourceMappingURL=chunk-LAMR6P2E.js.map
//# sourceMappingURL=chunk-LAMR6P2E.js.map